/**
 * Public Rewards marketing/checkout routes.
 * `/rewards` and `/rewards_v2` serve the same app (next.config rewrite).
 */

const REWARDS_BASE_RE = /^\/rewards(_v2)?(?=\/|$)/;

export function isRewardsPublicPath(path: string | null | undefined): boolean {
  if (!path) return false;
  return REWARDS_BASE_RE.test(path);
}

/** Keep the visitor on whichever alias they opened. */
export function getRewardsBasePath(
  pathname: string | null | undefined,
): "/rewards" | "/rewards_v2" {
  if (pathname === "/rewards" || pathname?.startsWith("/rewards/")) {
    return "/rewards";
  }
  return "/rewards_v2";
}

export function rewardsPath(
  pathname: string | null | undefined,
  subpath = "",
): string {
  const base = getRewardsBasePath(pathname);
  if (!subpath) return base;
  if (subpath.startsWith("#") || subpath.startsWith("?")) {
    return `${base}${subpath}`;
  }
  const suffix = subpath.startsWith("/") ? subpath : `/${subpath}`;
  return `${base}${suffix}`;
}
